//      
import React from "react";
                                                             
                                            
import "./PriceBox.scss";
import currencyConverter from "../helper/currency";
import {getTextColor} from "../helper/setTextColor";
import {useTranslation} from "react-i18next";
import PriceInfo from "./PriceInfo";
import {formatMeasuringUnit, resolvePriceDisplay} from "../helper/priceDisplay";

                      
                 
                                     
                      
                          
                               
                          
                        
                      
                       
                               
  

/**
 * Price section of the product detail page (#55467): current price with VAT note, the 30-day lowest
 * price (struck through with discount rate when the reduction is big enough) plus the price-details
 * popup, and the RRP as separate "originally" line unless disabled via data-disable-msrp.
 */
const PriceBox = (props               ) => {
    const {t} = useTranslation();

    const removeFromCart = e => {
        e.preventDefault();
        props.removeFromCart();
    };

    const addToCart = e => {
        e.preventDefault();
        props.addToCart(props.t);
    };

    const renderCartButton = () => {
        if (props.cartDisabled) return null;
        return props.isInCart
            ? <button type={"button"} data-testid={"cartButtonRemove"}
                      style={{color: getTextColor()}} className="sl-cart-cta toggle-card-add-00"
                      onClick={e => removeFromCart(e)}>
                {props.t("productDetail.priceBox.removeItem")}
            </button>
            : props.isCartLimitReached
                ? <button type={"button"} data-testid={"cartButtonLimited"}
                          style={{color: getTextColor()}} className="sl-cart-cta toggle-card-add-00"
                          onClick={e => e.preventDefault()}>
                    {props.t("navigation.maxBookmarksReached")}
                </button>
                : <button type={"button"} data-testid={"cartButtonAdd"}
                          style={{color: getTextColor()}} className="sl-cart-cta toggle-card-add-00"
                          onClick={e => addToCart(e)}>
                    {props.t("productDetail.priceBox.addItem")}
                </button>;
    };

    const renderPrices = () => {
        if (props.hidePrices) return null;
        const {product} = props.detailedProduct;
        const {mounting} = product.distributionChannels;
        const prices = resolvePriceDisplay(product);
        // a mountable product is always shown with its mounting price (incl. fitting), like before
        const price = mounting ? mounting.price : prices.price;
        const recommendedRetailPrice = mounting ? mounting.recommendedRetailPrice : prices.recommendedRetailPrice;
        const vatLabel = t(mounting ? "productDetail.priceBox.withVatAndMounting" : "productDetail.priceBox.withVat");
        const {unitPrice} = product;

        return <div data-testid={"pricebox"} className="price-box">
            {price && (
                <div className={"price" + (prices.isDiscounted ? " sale-price" : "")} data-testid={"currentPrice"}>
                    {currencyConverter(price)}
                </div>
            )}
            {price && (
                <div><small className="vat-label">{vatLabel}</small></div>
            )}
            {price && unitPrice && (
                <div><small className="unit-price">
                    ({currencyConverter(unitPrice.pricePerUnit)} / {formatMeasuringUnit(unitPrice.measuringUnit)})
                </small></div>
            )}
            {prices.historicMinimalPrice && (
                <div className="historic-price" data-testid={"historicMinimalPrice"}>
                    <small>
                        <span className="historic-label">{t("productDetail.priceBox.historicMinimalPurchasePrice")}:</span>
                        <PriceInfo
                            price={price}
                            historicMinimalPrice={prices.historicMinimalPrice}
                            recommendedRetailPrice={recommendedRetailPrice}
                            discountRate={prices.discountRate}
                            showMsrp={props.showMsrp}
                            vatLabel={vatLabel}
                        />
                        <span className={"historic-value" + (prices.isDiscounted ? " strikethrough" : "")}>
                            {currencyConverter(prices.historicMinimalPrice)}
                        </span>
                        {prices.isDiscounted && (
                            <span className="discount-rate" data-testid={"discountRate"}>-{prices.discountRate}%</span>
                        )}
                    </small>
                </div>
            )}
            {props.showMsrp && recommendedRetailPrice && (
                <div className="retail-price" data-testid={"retailPrice"}>
                    <small>
                        <span className="retail-label">{t("productDetail.priceBox.recommendedRetailPrice")}</span>
                        <span className="retail-value">{currencyConverter(recommendedRetailPrice)}</span>
                    </small>
                </div>
            )}
        </div>;
    };

    return (!props.hidePrices || !props.cartDisabled)
        ? <div>
			<span className="prices_detail">
                <span><small data-testid={"detailsArticleNo"}>
                    {props.t("productDetail.articleNumber")}: {props.detailedProduct.product.articleNumber}
                </small></span>
                <span>
                    {renderPrices()}
                    {renderCartButton()}
				</span>
			</span>
        </div>
        : null;
};

export default PriceBox;
